/**
 * Types for HomeQuestionCard component
 */

import { ReplacePlaceholdersResult } from "@/src/utils/getQuestionData";
import { useHomeQuestion } from "@/src/hooks/useHomeQuestion";

/**
 * @description HomeQuestionCard component props
 * @interface HomeQuestionCardProps
 */
export interface HomeQuestionCardProps {
  onSend: (v: string | undefined) => void;
  className?: string;
}

/**
 * @description QuickInsightsItemProps component props
 * @interface QuickInsightsItemProps
 */
export interface QuickInsightsItemProps {
  /**
   * @description Title of the card item
   * @type string
   * @required true
   * @example "Technical Analysis"
   */
  title?: string;

  /**
   * @description Background color for the card item
   * @type string
   * @required true
   * @example "dual-radial-bg1"
   */
  bg?: string;

  /**
   * @description Border color for the card item
   * @type string
   * @required true
   * @example "border-border_brand_solid/10"
   */
  border?: string;

  /**
   * @description Text color for the card item
   * @type string
   * @required true
   * @example "text-content_brand_primary"
   */
  color: string;

  /**
   * @description Description text for the card item
   * @type string
   * @required false
   * @default ""
   * @example "Access clear technical charts instantly for any ticker."
   */
  description?: string;
  /**
   * @description Callback when card item is clicked
   * @type function
   * @required false
   * @example () => setCategoryTab("Quick insights")
   */
  onClick?: (title: string) => void;
  /**
   * @description Icon for the card item
   * @type string
   * @required true
   * @example "icon-1"
   */
  icon?: string;
}

/**
 * @description Category item type for tab navigation
 * @interface CategoryItem
 */
export interface CategoryItem {
  /**
   * @description Unique key for the category
   * @type string
   * @required true
   * @example "quick_insights"
   */
  key: string;

  /**
   * @description Display title of the category
   * @type string
   * @required true
   * @example "Quick insights"
   */
  title: string;
  img: string;
}

/**
 * @description TabProps component props
 * @interface TabProps
 */
export interface TabProps {
  className?: string;
  /**
   * @description Title of the category
   * @type string
   * @required true
   * @example "Quick insights"
   */
  title: string;
  iconUrl: string;

  /**
   * @description Whether this category is active/highlighted
   * @type boolean
   * @required false
   * @default false
   * @example true
   */
  isActive?: boolean;

  /**
   * @description Callback when category is clicked
   * @type function
   * @required false
   * @example () => setCategoryTab("Quick insights")
   */
  onClick?: () => void;
}

/**
 * @description SearchQueryProps component props
 * @interface SearchQueryProps
 */
export interface SearchQueryProps {
  /**
   * @description Search query text
   * @type string
   * @required true
   * @example "What is $DOGE, why its price rose so much today?"
   */
  data: ReplacePlaceholdersResult;

  /**
   * @description Callback when question is clicked
   * @type function
   * @required false
   * @example () => setCategoryTab("Quick insights")
   */
  onQuestionClick?: ReturnType<typeof useHomeQuestion>["handleQuestion"];
}

export enum QuickTitleType {
  WHAT_IS_IT = "What is it",
  WHY_IT_MOVES = "Why it moves",
  SHOULD_I_BUY = "Should I Buy?",
  PRICE_PREDICTION = "Price prediction",
}

export interface ItemData {
  address: string;
  symbol: string;
  name: string;
  id: string;
}
